import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export function RequireAuth({ children }) {
    const { isAuthenticated, isLoading } = useAuth();
    const location = useLocation();
    if (isLoading) return <FullscreenLoader />;
    if (!isAuthenticated) {
        return <Navigate to="/login" replace state={{ from: location.pathname }} />;
    }
    return children;
}

export function RequireAdmin({ children }) {
    const { isAuthenticated, isLoading, role } = useAuth();
    if (isLoading) return <FullscreenLoader />;
    if (!isAuthenticated) return <Navigate to="/login" replace />;
    if (role !== "admin") return <Navigate to="/" replace />;
    return children;
}

function FullscreenLoader() {
    return (
        <div
            className="flex h-screen w-full items-center justify-center bg-background text-muted-foreground"
            data-testid="auth-loading"
        >
            <div className="flex items-center gap-3">
                <div className="h-2 w-2 animate-pulse rounded-full bg-primary" />
                <span className="text-sm">Sitzung wird geprüft...</span>
            </div>
        </div>
    );
}
